import { Emitter, Event } from "../../../../../features/event-emitter"
import { useCreditPaymentService } from "../../../services/creditPaymentService"

export const useActions = () => {
    const { uploadPaymentReceipt } = useCreditPaymentService()

    const submitReceipt = async (
        creditPaymentId: string,
        receiptFile: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        await uploadPaymentReceipt(creditPaymentId, receiptFile)
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
    }
    
    return {
        submitReceipt
    }
}
